<template>
    <span>{{ result }}</span>
</template>

<script>
import { computed, defineComponent } from "vue";
import { formatInputValue } from "../../input/template-builder/input-number/input-number.logic";

export default defineComponent({
    props: {
        text: {},
        column: {},
        maxDecimal: { default: 13 },
        allowMinus: { default: false },
        allowPrecision: { default: false },
        maxPrecision: { default: 2 },
        comma: { default: true },
        disabled: {},
        autoPrecision: { default: true },
        allowLeadZero: { default: true },
    },
    setup(props) {
        const result = computed(() => formatInputValue({ props: { ...props, value: props.text }, data: { focus: false } }));
        return { result };
    },
});
</script>
